import { Description, Root, Title, Trigger } from '@radix-ui/react-dialog'

import { DialogActionBar } from './DialogActionBar'
import { DialogBackground } from './DialogBackground'
import { DialogClose } from './DialogClose'
import { DialogContent } from './DialogContent'
import { DialogFooter } from './DialogFooter'
import { DialogHeading } from './DialogHeading'
import { DialogNavigationBar } from './DialogNavigationBar'
import { DialogScrollableContent } from './DialogScrollableContent'

export const Dialog = Object.assign(Root, {
  ActionBar: DialogActionBar,
  Background: DialogBackground,
  Close: DialogClose,
  Content: DialogContent,
  Heading: DialogHeading,
  Footer: DialogFooter,
  NavigationBar: DialogNavigationBar,
  ScrollableContent: DialogScrollableContent,

  Description: Description,
  Title: Title,
  Trigger: Trigger
})

Dialog.displayName = 'Dialog'
